module.exports = __webpack_public_path__ + "static/habitational-lessors-risk-insurance-c32747e42cce1e2a63c24a44f187fb17.svg";